import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=7b9bb0fd&scoped=true&"
import script from "./MainContent.ts?vue&type=script&lang=ts&"
export * from "./MainContent.ts?vue&type=script&lang=ts&"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=7b9bb0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9bb0fd",
  null
  
)

export default component.exports